export function getSelectedWarehouseId(): number | undefined {
    const urlSearchParams = new URLSearchParams(document.location.search);
    const warehouseParam = urlSearchParams.get('warehouse');
    return warehouseParam ? parseInt(warehouseParam, 10) : undefined;
}
